// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const ColorPickerContract = contract({
  name: "ColorPicker",
  description: "The token-led single-select colour picker — the focused \"pick one colour token\" sibling of FillPicker's solid tab. Use it anywhere a value is ONE Grade colour token (a fill colour, a border colour, an accent override) rather than a full paint. Composes Popover + Command exactly like Combobox, but each row is a Swatch + the token's short name, grouped by family and searchable. triggerVariant=\"inline\" reduces the trigger to a single clickable swatch — reach for that inside inspectors and the FillSection fill rows. For a full paint (gradient / image / shader) use FillPicker; for a list of fills use FillSection; for a multi-stop gradient use GradientEditor.",
  import: "@gradeui/ui",
  aliases: ["color picker","colour picker","token picker","colour token picker","color token picker","swatch picker","paint colour","fill colour picker","accent picker","colour dropdown"],
  composesWith: ["Popover","Command","Swatch","FillSection","GradientEditor","Field","PropertyList"],
  styleDefaults: {"ColorPicker":"ring-offset-background focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50","ColorRow":"ml-auto h-3.5 w-3.5"},
  props: {
  "value": {
      schema: z.string().optional(),
      design: "content",
      description: "a Grade colour token NAME (\"action/primary\"), the literal \"transparent\", or null when nothing is picked",
  },
  "onValueChange": {
      schema: z.unknown().optional(),
      design: "event",
      description: "fired with the next value (token name, \"transparent\", or null)",
  },
  "tokens": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "token families offered in the list; defaults to the Grade semantic set (surface / action / status)",
  },
  "searchable": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "show the search input (default true)",
  },
  "triggerVariant": {
      schema: z.enum(["default", "inline"]).optional(),
      design: "knob",
      description: "default = form-control surface (swatch + name); inline = just a clickable swatch for inspector / fill-row use",
  },
  "placeholder": {
      schema: z.string().optional(),
      design: "content",
      description: "trigger text when nothing is selected",
  },
  "searchPlaceholder": {
      schema: z.string().optional(),
      design: "content",
      description: "search-input placeholder",
  },
  "emptyMessage": {
      schema: z.string().optional(),
      design: "content",
      description: "shown when search returns no rows",
  },
  "allowTransparent": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "include a Transparent option at the top (default true)",
  },
  "align": {
      schema: z.enum(["start", "center", "end"]).optional(),
      design: "knob",
      description: "popover alignment (default start)",
  },
  "disabled": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "lock to a read-only display of the current value",
  },
  },
});
